import Amount from './Amount'
import Text from './Text'
import Editor from './Editor'
import Dict from './Dict'
import Html from './Html'
import Sign from './Sign'
import Post from './Post'
import Calculation from './Calculation'
import TimeDuration from './TimeDuration'
import DateDuration from './DateDuration'
import OrgTransfer from './OrgTransfer'
import OrgSelect from './OrgSelect'
import InputTable from './InputTable'
import QrCode from './QrCode'
import FormInputTable from './FormInputTable'
import DataSource from './DataSource'
const components = [
  Text,
  Editor,
  Dict,
  Html,
  Sign,
  Amount,
  Calculation,
  TimeDuration,
  DateDuration,
  OrgTransfer,
  OrgSelect,
  InputTable,
  Post,
  QrCode,
  FormInputTable,
  DataSource
]

const install = function ( Vue ) {
  components.map( component => {
    Vue.component( component.name, component )
  } )
}

export default {
  install
}
